import { getBackVersion } from '../config';
import { ActionPlanSnapshot } from '../models';
import api from './api';

const getActionPlans = (): Promise<ActionPlanSnapshot[]> =>
    api.request<ActionPlanSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/agent/action_plans`,
    });

export default { getActionPlans };
